import styled, { css } from "styled-components/native";
import { WheelPosition } from "../../Types";
import { StyledIconContainerProps } from "./model";

export const StyledView = styled.View<any>`
	width: 120px;
	height: auto;
	box-sizing: border-box;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.8);
	backdrop-filter: blur(10px);
	${(props) =>
		props.wheelPosition === WheelPosition.RIGHT
			? css`
					right: 0;
				`
			: css`
					left: 0;
				`}
	top: 112px;
	bottom: 0;
	position: fixed;
	z-index: 0;

	${(props) =>
		props.isNarrow &&
		css`
			top: 0;
			width: 80px;
		`}
`;

export const StyledIconContainer = styled.TouchableOpacity<StyledIconContainerProps>`
	height: 112px;
	width: 100%;
	align-items: center;
	justify-content: center;

	${(props) =>
		props.highlight &&
		css`
			background-color: #2362be;
		`}

	${(props) =>
		props.isNarrow &&
		css`
			height: 80px;
		`}
`;
